'use client'

import { useFormState, useFormStatus } from 'react-dom'
import { login } from '@/app/actions/auth'

function SubmitButton() {
  const { pending } = useFormStatus()
  return (
    <button
      type="submit"
      disabled={pending}
      className="w-full py-2.5 rounded-md bg-zinc-900 text-white text-sm font-medium transition-opacity disabled:opacity-60 hover:bg-zinc-800"
    >
      {pending ? '로그인 중…' : '로그인'}
    </button>
  )
}

export default function LoginPage() {
  const [state, formAction] = useFormState(login, null)

  const isUnauthorized = typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).get('error') === 'unauthorized'

  return (
    <main className="min-h-screen flex items-center justify-center bg-zinc-50">
      <div className="w-full max-w-sm px-4">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-zinc-900 text-white text-lg font-bold mb-3">
            S
          </div>
          <h1 className="text-xl font-semibold text-zinc-900">Bricks Studio</h1>
          <p className="text-sm mt-1 text-zinc-500">콘텐츠 입력기 (PD)</p>
        </div>

        <div className="rounded-lg p-6 bg-white border border-zinc-200">
          {isUnauthorized && (
            <p className="text-xs px-3 py-2 rounded-md mb-4 text-center bg-amber-50 text-amber-800 border border-amber-200">
              콘텐츠 PD 또는 관리자 계정으로만 로그인할 수 있습니다.
            </p>
          )}

          <form action={formAction} className="space-y-4">
            <div className="space-y-1.5">
              <label htmlFor="email" className="block text-xs font-medium text-zinc-700">
                이메일
              </label>
              <input
                id="email" name="email" type="email" autoComplete="email" required
                placeholder="pd@example.com"
                className="w-full px-3 py-2 rounded-md border border-zinc-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-zinc-400"
              />
            </div>

            <div className="space-y-1.5">
              <label htmlFor="password" className="block text-xs font-medium text-zinc-700">
                비밀번호
              </label>
              <input
                id="password" name="password" type="password" autoComplete="current-password" required
                placeholder="••••••••"
                className="w-full px-3 py-2 rounded-md border border-zinc-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-zinc-400"
              />
            </div>

            {state?.error && (
              <p className="text-xs rounded-md px-3 py-2 bg-red-50 text-red-700 border border-red-200">
                {state.error === 'Invalid login credentials'
                  ? '이메일 또는 비밀번호가 올바르지 않습니다.'
                  : state.error}
              </p>
            )}

            <SubmitButton />
          </form>
        </div>

        <p className="text-center text-xs mt-6 text-zinc-400">
          계정은 관리자에게 문의하세요.
        </p>
      </div>
    </main>
  )
}
